export default __webpack_public_path__ + "static/media/azure.75fc51c3.svg";